export enum ExternalRewardSource {
  ministryStudentSurvey2025 = 'ministry-survey-student-2025',
  ministryStudentSurvey2025Oct = 'ministry-survey-student-2025-oct',
  ministryStudentSurvey2026Feb = 'ministry-survey-student-2026-feb',
  ministryStudentSurvey2026May = 'ministry-survey-student-2026-may',
  ministryStudentSurvey2027H1 = 'ministry-survey-student-2027-h1',
  ministryStudentSurvey2027H2 = 'ministry-survey-student-2027-h2'
}
